var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isNewer)?_c('v-btn',_vm._g(_vm._b({attrs:{"data-cy":"Aurora-UpdateButton"},on:{"click":_vm.updateVersion}},'v-btn',_vm.$props,false),_vm.$listeners),[_vm._v(" Update Available ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }